/* global Routes */

class ActivityChecker {
  constructor() {
    this.timer = null;
  }

  checkActivity() {
    document.addEventListener('mousemove', () => this.resetTimer());
    document.addEventListener('keypress', () => this.resetTimer());
    this.resetTimer();
  }

  resetTimer() {
    clearTimeout(this.timer);
    this.timer = setTimeout(this.logOut, 180 * 60 * 1000);
  }

  logOut() {
    const link = document.createElement('a');
    link.href = Routes.destroy_user_session_path();
    link.setAttribute('data-method', 'delete');
    link.setAttribute('class', 'hidden');
    document.body.appendChild(link);
    link.click();
  }
}

export default ActivityChecker;
